<template>
    <!-- eslint-disable -->
    <v-container id="rfp-page" fluid tag="section">
        <v-row justify="center">
            <v-col cols="12">
                <base-material-card color="primary" class="px-5 py-3">
                    <template v-slot:heading>
                        <div class="display-2 font-weight-light">
                            Content
                        </div>
                        <div class="subtitle-1 font-weight-light">
                            This shows the Webinar(Future Talks) & Real-life Training details
                        </div>
                    </template>
                    <v-card-text>
                        <v-tabs v-model="tabs" color="primary" class="custom-tabs">
                            <v-tab>Webinar(Future Talks)</v-tab>
                            <v-tab>Real-life Training</v-tab>
                        </v-tabs>
                        <v-tabs-items v-model="tabs">
                            <v-tab-item>
                                <Webinar />
                            </v-tab-item>
                            <v-tab-item>
                                <RealLifeTraining />
                            </v-tab-item>
                        </v-tabs-items>
                    </v-card-text>

                </base-material-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import Webinar from "./Webinar.vue";
import RealLifeTraining from "./RealLifeTraining.vue";

export default {
    components: {
        Webinar,
        RealLifeTraining,
    },
    name: "Content",
    data: () => ({
        tabs: 0,
    }),
    computed: {},
    mounted() { },
    watch: {},
    methods: {
    },
};
</script>
<style>
@media (max-width: 600px) {
    .custom-tabs .v-tab {
        width: auto;
        margin: auto;
        padding: auto 10px;
        width: 120px;
    }
}
</style>
